window.addEventListener('DOMContentLoaded', () => {
	const customersCarousel = document.querySelector('.js-logos-wall-carousel');
	if (!customersCarousel) {
		return;
	}

	customersCarousel.querySelectorAll('.wp-block-image').forEach((item) => {
		item.classList.add('swiper-slide');
	});

	const swiper = new Swiper(customersCarousel, {
		slidesPerView: 1,
		spaceBetween: 32,
		loop: true,
		speed: 700,
		autoplay: {
			delay: 1500,
			disableOnInteraction: false,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 5,
			},
		},
	});
});
